<form
  [formGroup]="passwordForm"
  (ngSubmit)="onSubmit()"
  *ngIf="!submittionSuccess">
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
    <div class="col-span-1">
      <label
        for="old-password"
        class="mt-6"
        >{{ "changePassword.oldPassword" | translate }}</label
      >
      <div class="relative">
        <input
          id="old-password"
          [type]="showOldPassword ? 'text' : 'password'"
          formControlName="oldPassword"
          placeholder="Ancien mot de passe"
          [ngClass]="{
            'border-red ': !passwordForm.get('oldPassword')?.valid && passwordForm.get('oldPassword')?.touched,
          }"
          class="mt-1 block w-full px-3 py-2 border border-light rounded-md shadow-sm" />
        <i
          (click)="showOldPassword = !showOldPassword"
          class="pi cursor-pointer text-medium_light password-toggle-icon"
          [ngClass]="showOldPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
      </div>
      <small
        *ngIf="passwordForm.get('oldPassword')?.hasError('required') && passwordForm.get('oldPassword')?.touched"
        class="text-red">
        {{ "changePassword.oldPasswordError" | translate }}
      </small>
      <small
        *ngIf="apiErrorMessage && passwordForm.get('oldPassword')?.valid"
        class="text-red mt-4">
        {{ apiErrorMessage }}
      </small>
    </div>
    <div class="col-span-1">
      <div class="flex items-baseline -mt-6">
        <label
          for="new-password"
          class="mt-6"
          >{{ "changePassword.newPassword" | translate }}</label
        >
        <p-overlayPanel #op>
          <ng-template pTemplate="content">
            <app-popup-password-template></app-popup-password-template>
          </ng-template>
        </p-overlayPanel>
        <button
          pButton
          class="text-dark flex md:hidden"
          icon="pi pi-info-circle"
          (click)="op.toggle($event)"></button>
        <button
          pButton
          class="hidden md:flex md:flex-row text-dark"
          icon="pi pi-info-circle"
          [pTooltip]="passwordTooltip"></button>
        <ng-template #passwordTooltip>
          <app-popup-password-template></app-popup-password-template>
        </ng-template>
      </div>

      <div class="relative">
        <input
          id="new-password"
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="newPassword"
          placeholder="Nouveau mot de passe"
          [ngClass]="{
            'border-red ': !passwordForm.get('newPassword')?.valid && passwordForm.get('newPassword')?.touched,
          }"
          class="mt-1 block w-full px-3 py-2 border border-light rounded-md shadow-sm" />
        <i
          (click)="showNewPassword = !showNewPassword"
          class="pi cursor-pointer text-medium_light password-toggle-icon"
          [ngClass]="showNewPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
      </div>
      <div *ngIf="passwordForm.get('newPassword')?.touched">
        <small
          *ngIf="passwordForm.get('newPassword')?.hasError('required')"
          class="text-red">
          {{ "changePassword.newPasswordError" | translate }}
        </small>
        <small
          *ngIf="passwordForm.get('newPassword')?.hasError('minlength')"
          class="text-red">
          {{ "changePassword.newPasswordError2" | translate }}
        </small>
        <small
          *ngIf="passwordForm.get('newPassword')?.hasError('pattern')"
          class="text-red">
          {{ "changePassword.newPasswordError3" | translate }}
        </small>
      </div>
    </div>
    <div class="col-span-1">
      <label
        for="confirm-password"
        class="mt-6"
        >{{ "changePassword.confirmNewPassword" | translate }}</label
      >
      <div class="relative">
        <input
          id="confirm-password"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Nouveau mot de passe"
          [ngClass]="{
            'border-red ': !passwordForm.get('confirmPassword')?.valid && passwordForm.get('confirmPassword')?.touched,
          }"
          class="mt-1 block w-full px-3 py-2 border border-light rounded-md shadow-sm" />
        <i
          (click)="showConfirmPassword = !showConfirmPassword"
          class="pi cursor-pointer text-medium_light password-toggle-icon"
          [ngClass]="showConfirmPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
      </div>
      <div *ngIf="passwordForm.get('confirmPassword')?.touched">
        <small
          *ngIf="passwordForm.get('confirmPassword')?.hasError('required')"
          class="text-red">
          {{ "changePassword.confirmNewPasswordError" | translate }}
        </small>
        <small
          *ngIf="passwordForm.get('confirmPassword')?.hasError('minlength')"
          class="text-red">
          {{ "changePassword.confirmNewPasswordError2" | translate }}
        </small>
        <small
          *ngIf="passwordForm.get('confirmPassword')?.hasError('pattern')"
          class="text-red">
          {{ "changePassword.confirmNewPasswordError3" | translate }}
        </small>

        <small
          *ngIf="passwordForm.hasError('passwordMismatch')"
          class="text-red">
          {{ "changePassword.passwordMismatch" | translate }}
        </small>
      </div>
    </div>
  </div>
  <div class="flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0 mt-4">
    <div class="w-full mt-4 md:w-auto md:mt-0 order-2 md:order-1">
      <p-button
        class="border border-primary py-2 px-6 rounded-md"
        (click)="onCancel()">
        <span class="px-16">{{ "changePassword.cancelBtn" | translate }}</span>
      </p-button>
    </div>
    <div class="w-full md:w-auto order-1 md:order-2">
      <button
        pButton
        type="submit"
        [disabled]="!passwordForm.valid"
        [ngClass]="{
          'bg-opacity-50': !passwordForm.valid,
        }"
        class="bg-primary text-white py-2 px-6 w-full md:w-auto rounded-md shadow-md hover:bg-primary-600 transition duration-200 ease-in-out justify-center">
        <span class="px-16">{{ "changePassword.submitBtn" | translate }}</span>
      </button>
    </div>
  </div>
  <small
    *ngIf="errorMessage && passwordForm.valid"
    class="text-red mt-4"
    >{{ errorMessage }}</small
  >
</form>
<div
  class="flex items-center justify-center text-green my-4"
  *ngIf="submittionSuccess">
  <i class="pi pi-check"></i>
  <span class="ml-2 font-medium">{{ "changePassword.successMessage" | translate }}</span>
</div>

